(function () {
  function initCardVariantSwatches(scope) {
    var root = scope || document;
    var cardWrappers = root.querySelectorAll('.card-wrapper');

    cardWrappers.forEach(function (card) {
      if (card.dataset.variantSwatchesBound === 'true') return;
      card.dataset.variantSwatchesBound = 'true';

      var mediaHoverEffect = card.querySelector('.media--hover-effect');
      var images = mediaHoverEffect ? mediaHoverEffect.querySelectorAll('img') : [];
      var mainImage = images[0] || null;
      var secondaryImage = images[1] || null;

      if (!mainImage) return;

      var defaultMainSrc = mainImage.getAttribute('data-default-src') || mainImage.getAttribute('src') || '';
      var defaultMainSrcset = mainImage.getAttribute('data-default-srcset') || mainImage.getAttribute('srcset') || '';

      var defaultSecondarySrc = secondaryImage ? (secondaryImage.getAttribute('src') || '') : '';
      var defaultSecondarySrcset = secondaryImage ? (secondaryImage.getAttribute('srcset') || '') : '';

      var swatches = card.querySelectorAll('.card-variant-swatches__item');

      if (!swatches.length) return;

      function swapToVariant(swatch) {
        if (!swatch || swatch.classList.contains('card-variant-swatches__item--more')) return;

        var variantImage = swatch.getAttribute('data-variant-image') || '';
        var variantSrcset = swatch.getAttribute('data-variant-image-srcset') || '';

        if (!variantImage) return;

        card.classList.add('card--swatch-hovering');

        mainImage.setAttribute('src', variantImage);
        if (variantSrcset) {
          mainImage.setAttribute('srcset', variantSrcset);
        } else {
          mainImage.removeAttribute('srcset');
        }

        if (secondaryImage) {
          secondaryImage.setAttribute('src', variantImage);
          if (variantSrcset) {
            secondaryImage.setAttribute('srcset', variantSrcset);
          } else {
            secondaryImage.removeAttribute('srcset');
          }
        }
      }

      function swapBack() {
        card.classList.remove('card--swatch-hovering');

        if (defaultMainSrc) {
          mainImage.setAttribute('src', defaultMainSrc);
        }
        if (defaultMainSrcset) {
          mainImage.setAttribute('srcset', defaultMainSrcset);
        } else {
          mainImage.removeAttribute('srcset');
        }

        if (secondaryImage) {
          if (defaultSecondarySrc) {
            secondaryImage.setAttribute('src', defaultSecondarySrc);
          }
          if (defaultSecondarySrcset) {
            secondaryImage.setAttribute('srcset', defaultSecondarySrcset);
          } else {
            secondaryImage.removeAttribute('srcset');
          }
        }
      }

      swatches.forEach(function (swatch) {
        if (swatch.classList.contains('card-variant-swatches__item--more')) return;

        swatch.addEventListener('mouseenter', function () {
          swapToVariant(swatch);
        });

        swatch.addEventListener('focus', function () {
          swapToVariant(swatch);
        });

        swatch.addEventListener('mouseleave', function () {
          swapBack();
        });

        swatch.addEventListener('blur', function () {
          swapBack();
        });

        swatch.addEventListener(
          'touchstart',
          function () {
            swapToVariant(swatch);
          },
          { passive: true }
        );
      });

      card.addEventListener('mouseleave', swapBack);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCardVariantSwatches(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCardVariantSwatches(event.target);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    initCardVariantSwatches(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    initCardVariantSwatches(event.target);
  });

  window.initCardVariantSwatches = initCardVariantSwatches;
})();